{
  "plan_card": {
    "price": {
      "free_forever": "Free forever",
      "usd_per_month": "USD per month",
      "free_trial": "{days}-day free trial",
      "custom": "Custom"
    },
    "buttons": {
      "current_plan": "Current plan",
      "get_started": "Get started →",
      "start_free_trial": "Start free trial →",
      "select_plan": "Select plan",
      "speak_with_our_team": "Speak with our team"
    },
    "bullets": {
      "highlights_include": "Highlights include:",
      "everything_in_plus": "Everything in {previousPlan}, plus:",
      "need_more": "Need more?"
    }
  },
  "current_plan_card": {
    "badge": "Current plan"
  },
  "development_plan_banner": {
    "title": "We've detected you're installing SparkLayer on a development store",
    "description": "If your store is still in development, you can choose to skip billing for now and simply activate a plan once you're ready to go live.",
    "activate_button": "Activate development store",
    "errors": {
      "activation_failed_title": "Unable to activate development plan",
      "activation_failed_description": "There was a problem assigning the development plan to your store. Please contact support."
    }
  }
}
